<section
  [attr.aria-busy]="profileState().loading || saving()"
  class="settings-section"
>
  @if (profileState().loading) {
    <p role="status">{{ 'user-profile-settings.loading' | translate }}</p>
  } @else if (profileState().error) {
    <p role="alert">{{ 'user-profile-settings.load-error-' + profileState().error | translate }}</p>
    <proffeo-ui-button
      (click)="retryLoad()"
      text="user-profile-settings.retry"
      variant="secondary"
    />
  } @else if (profileState().loaded) {
    <proffeo-ui-select
      (valueChange)="onDraftChange($event)"
      [options]="languageOptions"
      [value]="effectiveDraft()"
      [disabled]="saving()"
      label="user-profile-settings.language"
    />
    <p class="settings-hint">{{ 'user-profile-settings.language-hint' | translate }}</p>
    <div class="settings-actions">
      <proffeo-ui-button
        (click)="discardChanges()"
        [disabled]="!isDirty() || saving()"
        text="user-profile-settings.cancel"
        variant="secondary"
      />
      <proffeo-ui-button
        (click)="save()"
        [disabled]="!isDirty()"
        [loading]="saving()"
        text="user-profile-settings.save"
      />
    </div>
    @if (saving()) {
      <p role="status">{{ 'user-profile-settings.saving' | translate }}</p>
    }
    @if (saveSucceeded()) {
      <p role="status">{{ 'user-profile-settings.saved' | translate }}</p>
    }
    @if (saveError()) {
      <p role="alert">{{ 'user-profile-settings.save-error' | translate }}</p>
    }
  }
</section>
